import React from "react";

export default function SafetyPolicy({name}) {
  return (
    <div>
      <h4 style={{ textAlign: "center" }}>Safety Policy</h4>
      <div style={{ display: "Flex", justifyContent: "space-between" }}>
        <p>
          <b>POLICY NUMBER:</b> 03012017
        </p>
        <p>
          <b>Effective Date:</b> Feb 01, 2021
        </p>
      </div>
      <h3>01. POLICY STATEMENT: </h3>
      <p>
        In keeping with our organization's commitment to constant pursuit of
        customer satisfaction & continual improvement of service one of which
        objective is fostering employee involvement and empowerment, Shah
        Transport has introduced the Speeding Policy. The success of this Policy
        is directly related to our positive involvement.
      </p>
      <h3>02. PURPOSE: </h3>
      <p>
        This Policy will help prevent collision and injuries to drivers and the
        public that Shah Transport serves. It is intended to reduce risky
        driving and use it to identity Shah Transport best drivers.
      </p>
      <h3>03. PROCEDURE: </h3>
      <p>
        We will monitor speeding reports and Driver Scorecard on weekly basis
        and identify target drivers. Drivers have to come in office and go
        through all speeding report and understand the importance for drive safe
        and speed limit. Speeding, sharp turns or other unsafe actions that
        could lead too collision.
      </p>
      <h3>04. RESPONSIBILITY: </h3>
      <p>
        It is the responsibility of all Drivers to adhere to safety rules and
        follow correct behaviour while driving. Failure to do so may result in
        disciplinary action which If deemed appropriate by the Owners' may
        include further action up to end including termination.
      </p>
      <p>
        <b>4.1</b>1st Violation written letter.{" "}
      </p>

      <p>
        <b>4.2</b>2nd Violation within 4 weeks — I week suspension{" "}
      </p>

      <p>
        <b>4.3</b>3rd Violation in 6 months — I week suspension{" "}
      </p>

      <p>
        <b>4.4</b>4th Violation within 5 months — Meeting with owners.{" "}
      </p>
      <p>I {name? <b>{name}</b> :""}	understand this speeding passenger policy and will abide with this policy at all Times, I also understand that failure to abide by the speeding policy is grounds for disciplinary action.</p>
    </div>
  );
}
